import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent }  from './app.component';
import { Configuration } from './app.constants';
import { routing, appRoutingProviders } from './app.routes';
import { HttpModule, JsonpModule } from '@angular/http';
import { HomeComponent } from './home/home.component';
//import { AboutComponent } from './about/about.component';
//import { AdminComponent } from './admin/admin.component';

//import {AdalService} from 'angular2-adal/core';
//import { ANGULAR2_ADAL_PROVIDERS } from './adal/ts/core';

//import { AdalService } from './adal/adal.service';
//import { ANGULAR2_ADAL_PROVIDERS } from './adal/index';
//import { AdalService } from './admin/adal/ts/services/adal.service';
//import { AdConfigService } from './services/adconfig.service';

import { AdminModule } from './admin/admin.module';
//import { AdalModule } from './services/adal.http.service';
import { AppSettingsService } from './services/appsettings.service';
import { UserInfoService } from './services/userinfo.service';
//import { HomeService } from './services/home.service'
//import { ProgressBarComponent } from './common/progressbar/progressbar.component'
//import { ProgressBarService } from './services/progressbar.service'
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { AdalService } from './adal/adal.service';


@NgModule({
    imports: [
        BrowserModule,
        
        HttpModule,
        JsonpModule,
        AdminModule,
        routing,
        SlimLoadingBarModule.forRoot()
        //ModalModule
        //AdalService
        //AdalModule.withConfig(new AdalService)
    ],

    declarations: [AppComponent, HomeComponent],//, AdminComponent],//, AboutComponent], ProgressBarComponent
    exports: [AppComponent, HomeComponent],
    providers: [
        appRoutingProviders,
        Configuration,
        AppSettingsService,
        UserInfoService,
        //HomeService,
        //ProgressBarService,
        //{ provide: APP_INITIALIZER, useFactory: (settings: AppSettingsService) => () => { settings.load() }, deps: [AppSettingsService], multi: true },
        AdalService
        //AdConfigService,
        //ANGULAR2_ADAL_PROVIDERS
    ],

    bootstrap: [AppComponent]//, AdConfigService] 
})

export class AppModule { }


// WEBPACK FOOTER //
// ./app/app.module.ts